// src/store/main/index.js

// Will export our module with all the actions, getters, mutations and the state

import actions from "./actions";
import getters from "./getters";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import { DetailStep } from "../models/enums";

const getInitialState = () => {
  return {
    loading: false,
    ref: null,
    stepHistory: [],
    currentStep: DetailStep.VORAUSWAHL_START,
    preInterest: null, // VorauswahlInteresse
    preInterestFreiwillig: null, // VorauswahlFreiwillig
    preDriverLicence: null, // VorauswahlFührerschein
    preDriverLicenceDetails: {
      number: null,
      skipForNow: false,
    },
    newDriverLicenceClasses: [],
    selectedVehicletype: null,
    allTrainings: [],
    allCourses: [],
    selectedTraining: null,
    selectedCourses: {
      // empty dictionary
      // "A": { ... },
    },
    allLocations: [],
    selectedLocation: null,
    borrowVehicle: null,
    pi: {
      // personal information
      firstname: null,
      lastname: null,
      birthdate: null,
      street: null,
      housenumber: null,
      postalcode: null,
      city: null,
      country: "AUT",
      citizenship: "AUT",
      email: null,
      phone: null,
    },
    acceptDataPrivacy: false,
    isDev: process.env.NODE_ENV == "development",
  };
};

let state = getInitialState();

let mutations = {
  setLoadingState(state, payload) {
    state.loading = payload;
  },
  updateRef(state, payload) {
    state.ref = payload;
  },
  resetState(state) {
    Object.assign(state, getInitialState());
  },
  updateStep(state, payload) {
    state.stepHistory = [...state.stepHistory, state.currentStep];
    state.currentStep = payload;
  },
  stepBack(state) {
    state.currentStep = state.stepHistory.pop();
  },
  updatePreInterest(state, payload) {
    state.preInterest = payload;
  },
  updatePreInterestFreiwillig(state, payload) {
    state.preInterestFreiwillig = payload;
  },
  updatePreDriverLicence(state, payload) {
    state.preDriverLicence = payload;
  },
  updateVehicletype(state, payload) {
    state.selectedVehicletype = payload;
  },
  updatePreDriverLicenceDetailsNumber(state, payload) {
    state.preDriverLicenceDetails = {
      ...state.preDriverLicenceDetails,
      number: payload,
    };
  },
  updatePreDriverLicenceDetailsSkipForNow(state, payload) {
    state.preDriverLicenceDetails = {
      ...state.preDriverLicenceDetails,
      skipForNow: payload,
    };
  },
  toggleNewDriverLicenceClasses(state, payload) {
    if (state.newDriverLicenceClasses.includes(payload)) {
      state.newDriverLicenceClasses = state.newDriverLicenceClasses.filter(
        (c) => c != payload
      );
    } else {
      state.newDriverLicenceClasses = [
        ...state.newDriverLicenceClasses,
        payload,
      ];
    }
  },
  updateAllTrainings(state, payload) {
    state.allTrainings = payload;
  },
  updateAllCourses(state, payload) {
    state.allCourses = payload;
  },
  updateAllLocations(state, payload) {
    state.allLocations = payload;
  },
  updateSelectedLocation(state, payload) {
    state.selectedLocation = payload;
  },
  updateSelectedTraining(state, payload) {
    state.selectedTraining = payload;
  },
  updateSelectedCourses(state, payload) {
    state.selectedCourses[payload.classs] = payload.course;
  },
  resetSelectedCourses(state) {
    state.selectedCourses = {};
  },
  updateBorrowVehicle(state, payload) {
    state.borrowVehicle = payload;
  },
  updatePi(state, payload) {
    state.pi[payload.key] = payload.value;
  },
  updateAcceptDataPrivacy(state, payload) {
    state.acceptDataPrivacy = payload;
  },
};

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => {
    // Exclude the "loading" key from the persisted state
    // eslint-disable-next-line no-unused-vars
    const { currentStep, loading, ...restState } = state;
    return restState;
  },
});

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [vuexLocal.plugin],
});
